import React, { useEffect, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import { styled } from '@material-ui/core/styles';
import { MuiThemeProvider, CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Router } from 'react-router';
import LuxonUtils from '@date-io/luxon';
import theme from './theme';
import { Provider as ConfigProvider } from './context/config';
import { Provider as HistoryProvider } from './context/history';
import _FatalErrorScreen from './screens/FatalErrorScreen';
import _SignedInScreen from './screens/SignedInScreen';
import _SignedOutScreen from './screens/SignedOutScreen';
import SigningInIndicatorScreen from './components/SigningInIndicatorScreen';
import DocumentTitle from './components/DocumentTitle';
import { MeDocument, GetOrganizationsFromIdDocument } from '../generated/graphql';
import { commands } from '../operations/commands';
import { currentUserVar, availableOrganizationsVar, lastAccessedOrganizationVar } from '../cache';
var Root = function (props) {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    useEffect(function () {
        Promise.all([
            props.apolloClient
                .query({
                query: MeDocument,
                errorPolicy: 'all',
            })
                .then(function (result) {
                var _a;
                commands.setCurrentUser((_a = result.data) === null || _a === void 0 ? void 0 : _a.me);
            }),
            props.idApolloClient
                .query({
                query: GetOrganizationsFromIdDocument,
                variables: { permissionActions: ['ORGANIZATIONS_READ'] },
            })
                .then(function (result) {
                commands.setAvailableOrganizations(result.data.organizations);
                if (!lastAccessedOrganizationVar()) {
                    commands.setLastAccessedOrganization(result.data.organizations[0]);
                }
            }),
        ])
            .catch(function (error) {
            commands.setErrors(error);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [currentUserVar(), availableOrganizationsVar()]);
    return (React.createElement(MuiPickersUtilsProvider, { utils: LuxonUtils },
        React.createElement(ConfigProvider, { value: props.config },
            React.createElement(ApolloProvider, { client: props.apolloClient },
                React.createElement(HistoryProvider, { value: props.history },
                    React.createElement(Router, { history: props.history },
                        React.createElement(MuiThemeProvider, { theme: theme },
                            React.createElement(CssBaseline, null),
                            React.createElement(RootElement, null,
                                React.createElement(DocumentTitle, null),
                                React.createElement(StyledSigningInIndicatorScreen, { visible: loading }),
                                React.createElement(FatalErrorScreen, null),
                                React.createElement(SignedOutScreen, null),
                                React.createElement(SignedInScreen, null)))))))));
};
var RootElement = styled('div')({
    position: 'relative',
    minWidth: 1024,
    width: '100%',
    height: '100%',
});
var FatalErrorScreen = styled(_FatalErrorScreen)({
    width: '100%',
    height: '100%',
});
var SignedOutScreen = styled(_SignedOutScreen)({
    width: '100%',
    height: '100%',
});
var SignedInScreen = styled(_SignedInScreen)({
    width: '100%',
    height: '100%',
});
var StyledSigningInIndicatorScreen = styled(SigningInIndicatorScreen)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 10000,
});
export default Root;
